module.exports = __webpack_public_path__ + "img/40_37_012_240.3e6e9325.jpg";